// Per-site configuration for this deployed theme build.
//
// This file is the ONE place a site branch (web/<site>/develop) overrides to
// point the theme at its own manager "theme" record. When fanning this out to
// another site, change SITE_PREFIX to that site's manager prefix — nothing else
// here is site-specific.
//
//   - SITE_PREFIX      the manager Theme.prefix this build maps to. NOTE the
//                      manager stores short UPPERCASE codes, not the branch
//                      slug: hkt956 → 'HKT', pixxie928 → 'PIX', rpg168 → 'RPG',
//                      snc168 → 'SNC', tg168 → 'TG', tos168 → 'TOS'. The theme
//                      fetches its operator-config keyed by this exact value.
//   - MANAGER_ENDPOINT base URL of the wp-themes-manager-api (the internal
//                      admin backend), NOT the runtime hkthg.com API. Points at
//                      the live manager; override for local dev if needed.

export const SITE_PREFIX = 'RPG';

export const MANAGER_ENDPOINT = 'https://api.bo-vegar168.app/api/v1';

// Resolve a manager-provided image ref to a browser-loadable URL. Manager images
// arrive either as a self-contained `data:` URI (works as-is) or as a RELATIVE
// path like `/api/v1/images/f/<id>` — the latter must be resolved against the
// manager origin, NOT the WordPress site origin, or the browser 404s it. Already
// absolute http(s) URLs pass through untouched.
export const resolveManagerImage = (img?: string): string => {
	if (!img) return '';
	if (/^(https?:|data:)/i.test(img)) return img;
	const origin = new URL(MANAGER_ENDPOINT).origin;
	return origin + (img.startsWith('/') ? img : '/' + img);
};

// Product codes (the runtime API's `productCode`) hidden from this site: the
// provider list and the search results on the game page, the recommended list,
// the mixed-provider categories, and the favourite / recently-played popups.
// The runtime API keeps returning them, so the theme filters them out
// client-side. Empty on purpose since 2026-09-30: every provider the API
// returns is shown (Askmeslot / AMBS was hidden 2026-09-07 → 2026-09-30 and
// brought back by operator decision). Add a code here to hide a provider again.
export const HIDDEN_PRODUCT_CODES: string[] = [];

// Match on BOTH `productCode` and `productName`: the runtime API is not
// consistent about which of the two carries the short code, so checking only
// one field lets the provider slip through on some endpoints.
export const isHiddenProduct = (item: { productCode?: string; productName?: string }): boolean =>
	HIDDEN_PRODUCT_CODES.includes(item.productCode || '') ||
	HIDDEN_PRODUCT_CODES.includes(item.productName || '');
